import { Header as TableHeader, flexRender } from "@tanstack/react-table";
import { cn } from "@theprelude/core";
import { ArrowDown, ArrowUp, SortIcon } from "@theprelude/ds";

export const Header: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="flex w-max flex-row items-center gap-2 text-base text-primary-foreground font-medium">
      <span>{children}</span>
    </div>
  );
};

export const SortIndicator: React.FC<{
  order: "asc" | "desc" | false;
}> = ({ order }) => {
  if (order === "asc") {
    return (
      <ArrowUp className="h-4 w-4 text-secondary-foreground hover:fill-primary-foreground" />
    );
  } else if (order === "desc") {
    return (
      <ArrowDown className="h-4 w-4 text-secondary-foreground hover:fill-primary-foreground" />
    );
  } else {
    return (
      <SortIcon className="h-4 w-4 text-secondary-foreground hover:fill-primary-foreground" />
    );
  }
};

export const SortedHeader: React.FC<{
  header: TableHeader<any, any>;
}> = ({ header }) => {
  const headerEl = header.column.columnDef.meta?.label ? (
    <Header>{header.column.columnDef.meta.label}</Header>
  ) : (
    header.column.columnDef.header
  );
  return (
    <th
      {...{
        key: header.id,
      }}
    >
      <div
        className={cn(
          "flex flex-row items-center gap-2 hover:cursor-pointer hover:select-none",
        )}
        onClick={header.column.getToggleSortingHandler()}
      >
        {flexRender(headerEl, header.getContext())}

        {header.column.getCanSort() &&
          !header.column.columnDef.meta?.hideSorting && (
            <SortIndicator order={header.column.getIsSorted()} />
          )}
      </div>
    </th>
  );
};

export const VirtualSortedHeader: React.FC<{
  header: TableHeader<any, any>;
}> = ({ header }) => {
  const headerEl = header.column.columnDef.meta?.label ? (
    <Header>{header.column.columnDef.meta.label}</Header>
  ) : (
    header.column.columnDef.header
  );
  return (
    <th key={header.id} className={cn("flex p-2")}>
      <div
        className={cn(
          "flex flex-row items-center gap-2 hover:cursor-pointer hover:select-none",
        )}
        onClick={header.column.getToggleSortingHandler()}
      >
        {flexRender(headerEl, header.getContext())}

        {header.column.getCanSort() &&
          !header.column.columnDef.meta?.hideSorting && (
            <SortIndicator order={header.column.getIsSorted()} />
          )}
      </div>
    </th>
  );
};
